import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useComparison } from '../contexts/ComparisonContext';
import { X, ArrowRight } from 'lucide-react';

const ComparisonBar = () => {
  const { selectedVehicles, removeVehicle, clearAll, count } = useComparison();
  const navigate = useNavigate();

  if (count === 0) return null;

  const handleCompare = () => {
    const ids = selectedVehicles.map(v => v.vehicle_id).join(',');
    navigate(`/compare?ids=${ids}`);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-surface border-t border-white/10 shadow-2xl z-40 animate-slide-up">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-4">
          {/* Selected Vehicles */}
          <div className="flex items-center gap-3 flex-1 overflow-x-auto">
            <span className="text-sm text-textSecondary whitespace-nowrap">
              Compare ({count}/3):
            </span>
            <div className="flex gap-3">
              {selectedVehicles.map((vehicle) => (
                <div
                  key={vehicle.vehicle_id}
                  className="relative group flex-shrink-0 w-24 h-16 rounded-sm overflow-hidden border border-white/10"
                >
                  <img
                    src={vehicle.images?.[0] || '/placeholder.jpg'}
                    alt={`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
                    className="w-full h-full object-cover"
                  />
                  <button
                    onClick={() => removeVehicle(vehicle.vehicle_id)}
                    className="absolute top-1 right-1 bg-black/70 hover:bg-primary rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                    aria-label="Remove from comparison"
                  >
                    <X className="w-3 h-3" />
                  </button>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-1">
                    <p className="text-[10px] font-medium truncate">
                      {vehicle.year} {vehicle.make}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-3">
            <button
              onClick={clearAll}
              className="text-sm text-textSecondary hover:text-white transition-colors whitespace-nowrap"
            >
              Clear All
            </button>
            <button
              onClick={handleCompare}
              className="bg-primary hover:bg-primaryHover text-white font-bold px-6 py-3 rounded-sm flex items-center gap-2 transition-colors whitespace-nowrap"
            >
              Compare Now
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonBar;
